import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';

/**
 * Hook para verificar se o usuário tem perfil completo
 * e redirecionar para a tela de completar perfil se necessário
 */
export const useProfileCheck = (redirectPath: string = '/profile/complete', shouldRedirect: boolean = true) => {
  const { authState } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    // Só verificar se o usuário está autenticado e não está carregando
    if (shouldRedirect && authState.isAuthenticated && !authState.isLoading) {


      // Se não tem perfil completo, redirecionar
      if (!authState.hasCompleteProfile) {

        navigate(redirectPath, { replace: true });
      }
    }
  }, [authState.isAuthenticated, authState.isLoading, authState.hasCompleteProfile, navigate, redirectPath, shouldRedirect]);

  return {
    hasCompleteProfile: authState.hasCompleteProfile,
    profileId: authState.profileId,
    isLoading: authState.isLoading,
    needsProfileCompletion: authState.isAuthenticated && !authState.hasCompleteProfile
  };
};

export default useProfileCheck;